import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { useDispatch } from "react-redux";
import { onboardingApi } from "../services";
import errorReducer from "../slices/errorSlice";
import guarantorReducer from "../slices/guarantorSlice";

export type AppState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = typeof store.dispatch;

const rootReducer = combineReducers({
	[onboardingApi.reducerPath]: onboardingApi.reducer,
	error: errorReducer,
	guarantors: guarantorReducer,
});

export const setupStore = (preloadedState?: AppState) =>
	configureStore({
		reducer: rootReducer,
		middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(onboardingApi.middleware),
		preloadedState,
	});

export const store = setupStore();
export const useAppDispatch: () => AppDispatch = useDispatch;

setupListeners(store.dispatch);
